<template>
  <div>
    <el-select :value="selected" @input="dispatch" :placeholder="placeholder || $t('message.role')" filterable clearable
      :size="size" class="d-block">
      <el-option v-for="(role,index) in roles" :key="'roles-' + index" :label="role.name" :value="role.id"></el-option>
    </el-select>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from "vuex";
  import { i18n  } from '@/utils/i18n';
  export default {
    props: {
      size: {
        default: 'small'
      },
      placeholder: {
        default: null,
      },
      id:{
        default: null
      }
    },
    watch:{
      id:{
        handler: function() {
            this.selected = this.id
        },
        immediate: true
      }
    },
    data() {
      return {
        selected: null,
      }
    },
    mounted() {
      if (this.roles && this.roles.length === 0) this.updateInventory()
    },
    computed: {
      ...mapGetters({
        roles: 'roles/inventory'
      })
    },
    methods: {
      ...mapActions({
        updateInventory: 'roles/inventory'
      }),
      dispatch(e) {
        this.$emit('input', e)
        this.selected = e
      }
    },
  }

</script>
